// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__D7gIf","footerLabel":"Footer_footerLabel__1cnYO"};